import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelRemoveSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2h12v1.276a2 2 0 0 1-.464 1.28L9.464 9.444A2 2 0 0 0 9 10.724V14l-2 1v-4.276a2 2 0 0 0-.464-1.28L2.464 4.556A2 2 0 0 1 2 3.276V2Zm4.525 2.475.768.768-.768.767.707.708L8 5.95l.768.768.707-.708-.768-.767.768-.768-.707-.707L8 4.536l-.768-.768-.707.707Z"
    />
  </svg>
);
export default IconFunnelRemoveSizeS;
